export default __webpack_public_path__ + "static/media/Support-Scenario-Menu-A.de1ae4e3.png";